import { Box, Typography, useTheme } from '@mui/material';

type Props = {
  displayedCondition: string;
};

export const AlarmTriggerConditionItem = ({ displayedCondition }: Props) => {
  const theme = useTheme();
  return (
    <Box
      data-sm={displayedCondition}
      sx={{ padding: '4px 8px', borderRadius: '6px', background: theme.palette.primary.lighter }}
    >
      <Typography sx={{ color: theme.palette.primary.main, fontWeight: '700', fontSize: '12px' }}>
        {displayedCondition}
      </Typography>
    </Box>
  );
};
